let os = 'unknown';

const setOS = (val) => {
    os = val;
};

const getOS = () => os;

export { setOS, getOS };
